import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTrustpilotComponent } from './simple-icons-trustpilot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTrustpilotComponent ],
    exports:      [ SimpleIconsTrustpilotComponent ],
    bootstrap:    []
})
export class SimpleIconsTrustpilotModule {}
